import { render, staticRenderFns } from "./Updos.vue?vue&type=template&id=5ecde78c&lang=pug&"
import script from "./Updos.vue?vue&type=script&lang=ts&"
export * from "./Updos.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports